import React from "react";
import { connect } from "react-redux";
import { SetDepositMemberBanksActive, GetDepositMemberBanks } from '$Deposits/store/actions/DepositAction'
import { GetParamsData, bankCodeWriting } from '$Deposits/lib/LibCommonData'

class UserBankSelect extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            bankModal: false,
            activeBank: '',
        };

    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }

    render() {
        const { goAddBankInfo } = GetParamsData()

        const {
            SetDepositMemberBanksActive,
            DepositMemberBanksActive,
            DepositMemberBanks = [],
            UserBankSelect,
            MethodsActive,
            GetDepositMemberBanks,
        } = this.props;

        // 是否显示添加按钮
        const showAddUserBank = DepositMemberBanks.length > 2? false: true
        return (

            <>
                <UserBankSelect
                    onChange={SetDepositMemberBanksActive}
                    DepositMemberBanksActive={DepositMemberBanksActive}
                    BankList={DepositMemberBanks}
                    AddBankClick={(bankLength) => {
                        goAddBankInfo(() => { GetDepositMemberBanks() }, bankLength)
                    }}
                    methods={MethodsActive.code || ''}
                    showAddUserBank={showAddUserBank}
                />
            </>
        );
    }
}

const mapStateToProps = state => ({
    DepositMemberBanks: state.DepositMemberBanks,
    DepositMemberBanksActive: state.DepositMemberBanksActive,
    MethodsActive: state.MethodsActive,
});
const mapDispatchToProps = {
    SetDepositMemberBanksActive: (data = {}) => SetDepositMemberBanksActive(data),
    GetDepositMemberBanks: () => GetDepositMemberBanks(),
};
export default connect(mapStateToProps, mapDispatchToProps)(UserBankSelect);

